import { PhoneMissed } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SiteNavigationTab } from '~/pages/Home/SiteNavigation/shared/SiteNavigationTab'
import { TabImplementationProps } from '~/pages/Home/SiteNavigation/tabImplementations/TabImplementationTypes'

export const MissedCallsTab = ({
  id,
  isSelected,
  isCollapsed,
  onClick,
}: TabImplementationProps) => {
  const { t } = useTranslation()

  return (
    <SiteNavigationTab
      id={id}
      title={t('nav.missedCalls')}
      icon={PhoneMissed}
      isSelected={isSelected}
      isCollapsed={isCollapsed}
      onClick={onClick}
    />
  )
}
